import { reactive } from 'vue'

let characters

export default function () {
  if (!characters) {
    try {
      const json = localStorage.getItem('__com.jordanranson.dungeonexpress__characters')
      if (json) characters = reactive(JSON.parse(json))
      else characters = reactive([])
    } catch (err) {
      console.warn('Error deserializing state', err)
      characters = reactive([])
    }
  }

  const save = () => {
    localStorage.setItem('__com.jordanranson.dungeonexpress__characters', JSON.stringify(characters))
  }

  const addCharacter = (character) => {
    characters.push(character)
    save()
  }

  const removeCharacterById = (id) => {
    const index = characters.findIndex((character) => character.id === id)
    characters.splice(index, 1)
    save()
  }

  return {
    save,
    characters,
    addCharacter,
    removeCharacterById
  }
}
